import { API } from "@infra/api";
import type { Company } from "@domain/CRM/company";
import { makeImportSettingsUseCases } from "@app/imports";
import { logger } from "@infra/logger";
import type { ICompanies } from "@ports/companies/ICompanies";

const companiesApi: ICompanies = {
	getByFilter: (filter) => API.Data.Companies.get.byFilter(filter) as Promise<Company[]>,
	updatePortalSettings: (id, settings) => API.Data.Companies.update.portalSettings(id, settings),
	updatePortalConfigurationOptions: (id, options) => API.Data.Companies.update.portalConfigurationOptions(id, options),
};

export const importSettingsUseCases = makeImportSettingsUseCases({ companiesApi, logger });
